import { UserDefinedNotificationConfig } from '@apis/Notification/model';
import { QueryExpr } from '@apis/Resources';
import styled from '@emotion/styled';
import { OptionMenuItemTypes } from '@root/Components/Picker/OptionMenu';
import { FillerSwitch } from '@root/Design/Filler';
import { useDiMemo } from '@root/Services/DI';
import { EventEmitter } from '@root/Services/EventEmitter';
import { QueryDatasource } from '@root/Services/Query/QueryDatasource';
import { QueryDatasourceCollection } from '@root/Services/Query/QueryDatasourceCollection';
import { useEffect, useMemo, useState } from 'react';
import { ChartConfig, StandaloneChartRenderer } from '../../DashboardLayout/Charts/ChartRenderer';

export function NotificationSnapshotContent(props: {
    config: UserDefinedNotificationConfig;
    snapshot: string;
    menuItems: EventEmitter<OptionMenuItemTypes[]>;
}) {
    const { config, menuItems, snapshot: rawData } = props;
    const data = useMemo(() => JSON.parse(rawData), [rawData]);
    const { ComponentConfig, QueryOptions } = config;
    const componentCfg = ComponentConfig as unknown as ChartConfig;
    const { DatasourceName, Parameters } = QueryOptions ?? {};

    const datasourceCollection = useDiMemo(QueryDatasourceCollection);
    const [datasource, setDatasource] = useState<QueryDatasource>();

    useEffect(() => {
        if (DatasourceName) {
            (async () => {
                const datasource = await datasourceCollection.getDatasource(DatasourceName ?? '', {}, true);
                datasource.source = () => {
                    return Promise.resolve(data[0]);
                };
                setDatasource(datasource);
            })();
        }
    }, [JSON.stringify({ DatasourceName, Parameters }), config]);

    const filters = useMemo(() => (config.QueryOptions?.Filters ?? []) as QueryExpr[], [JSON.stringify(config.QueryOptions?.Filters)]);

    return (
        <NotificationContentBody>
            <FillerSwitch loading={!datasource}>
                {() => (
                    <StandaloneChartRenderer
                        config={componentCfg}
                        datasource={datasource!}
                        filters={filters}
                        menuItemsRequest={menuItems}
                        containerProps={{ border: 'none', padding: '0px', borderRadius: '0px' }}
                    />
                )}
            </FillerSwitch>
        </NotificationContentBody>
    );
}

export const NotificationContentBody = styled.div`
    height: 400px;
`;
